module.exports = __webpack_public_path__ + "static/media/serena_tex.b0f31bae.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/serenaHome2/serena_tex.png
// module id = 134
// module chunks = 0